<template>
  <div class="modal-container" v-if="hasModal">
    <component :is="modal.component" :options="modal.options" @resolve="resolve" @close="close" />
  </div>
</template>

<script>
export default {
  props: {
    modal: { type: Object }
  },
  computed: {
    hasModal() {
      return _.isObject(this.modal) && _.has(this.modal, "component");
    }
  },
  methods: {
    resolve(response) {
      if (typeof this.modal.resolveHandler !== "undefined") {
        this.modal.resolveHandler(response);
      }
    },
    close() {
      if (typeof this.modal.closeHandler !== "undefined") {
        this.modal.closeHandler();
      }
    }
  }
};
</script>